import { render, staticRenderFns } from "./GapEditor.vue?vue&type=template&id=1b0913a1&"
import script from "./GapEditor.vue?vue&type=script&lang=ts&"
export * from "./GapEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports